/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
// import {Get_Property_Type, Get_Carpet_Unit} from './Property_Api'
// import './propertyNewHome_styles/propertyNewHome.css'
import { FormikValues } from 'formik'
// import {propertyTypeDataType, carpetAreaUnitDataType} from './PropertyDataTypes'
import Swal from 'sweetalert2'
import AddPropertyForLead from './AddPropertyForLead'
import Multiselect from 'multiselect-react-dropdown'
import { propertyUpdate } from '../LeadManagementAPI'
import styles from '../LeadManagementStyles/LeadManagementStyle.module.scss'

const ViewLeadStep1 = ({ leads_data_uuid,
    lead_property_details,
    propertyList,
    getLeadList,
    show,
    handleClose,
    setSuccessMsg,
    setError, acceptedProperty }: any) => {
    // const [propertyList, setPropertyList] = useState()
    const [selectedProperties, setSelectedProperties] =
        useState(lead_property_details)
    const [submitBtnLoading, setSubmitBtnLoading] = useState<boolean>(false)
    // function executes after removing the properties from the multiselect
    const onremoveProperties = (selectedList: any) => {
        setSelectedProperties(selectedList)
    }

    // function executes after selecting the properties from the multiselect
    const onSelectProperties = (selectedList: any) => {
        // propertiesDataType[]
        setSelectedProperties(selectedList)
    }

    // function to add or update the properties for the lead
    const handleAddProperty = async () => {
        setSubmitBtnLoading(true)
        try {
            const { data: response } = await propertyUpdate(leads_data_uuid, selectedProperties)
            if (response.code === '200') {
                // handleClose()
                getLeadList()
                setSuccessMsg('Success: Properties updated successfully')
            } else {
                setError(`Error: ${response.msg_details}`)
            }
        } catch (error: any) {
            setError(`Error: ${error}`)
        } finally {
            setSubmitBtnLoading(false)
        }
    }
    useEffect(()=>{
        setSelectedProperties(lead_property_details)
    },[lead_property_details])
    return (
        <div className='current' data-kt-stepper-element='content'>
            <div className='w-100 d-flex flex-column'>
                <h4 className='text-primary'>Add Properties</h4>
                {acceptedProperty.length > 0 ? <p className='text-danger pb-0 mb-0'>Updating properties is not allowed if property is accepted</p> : null}
                {/* <div className=''> */}
                {/* Begin: Modal body */}
                <div className='modal-body p-0 row w-100'>
                    {/* Begin: field multiselect to select the properties for leads */}
                    <div className='col-12 col-lg-9 mt-2'>
                        <Multiselect
                            className={`form-control-md form-control-solid ${styles.bg_primary}`}
                            displayValue='property_title'
                            placeholder='Select Properties for Lead'
                            onKeyPressFn={function noRefCheck() { }}
                            onRemove={onremoveProperties}
                            onSearch={function noRefCheck() { }}
                            selectedValues={selectedProperties}
                            onSelect={onSelectProperties}
                            options={propertyList}
                            showCheckbox
                            disable={acceptedProperty.length > 0 ? true : false}
                        />
                    </div>
                    {/* End: field multiselect to select the properties for leads */}
                    {/* <div className={`fv-row mb-2 mt-4`}> */}
                    <div className='col-12 col-lg-3 mt-2'>
                        {/* Begin:: submit button */}
                        <button
                            type='button'
                            onClick={handleAddProperty}
                            className={`w-100 btn btn-lg ${(submitBtnLoading || acceptedProperty?.length > 0)?'btn-secondary' :'btn-primary'}`}
                            disabled={submitBtnLoading || acceptedProperty?.length > 0}
                        >
                            {submitBtnLoading ? (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    Processing...
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                            ) : (
                                'Update properties'
                            )}
                        </button>
                        {/* End:: submit button */}
                    </div>
                </div>
                {/* End: Modal body */}
                {/* </div> */}
            </div>
        </div>
    )
}

export default ViewLeadStep1
